/**
 * Relatives Alter eines Zeitstempels in der groebsten noch sinnvollen Einheit.
 *
 * Lag bis zum Pruefdatum im Feed-Check-Kopf als lokale Funktion im Kopf von
 * `FeedHealthDashboard.tsx`. Seit der Befund sein Alter auch im Kopf nennt,
 * brauchen Seite und Kopf dieselbe Rechnung, und zwei Kopien waeren eine
 * stille Drift-Quelle.
 *
 * Der Uebersetzer kommt als Parameter herein, statt dass die Funktion selbst
 * `useTranslation` ruft: sie bleibt damit ausserhalb von React aufrufbar und
 * ohne i18next-Instanz testbar.
 */
export type TimeAgoTranslate = (key: string, opts?: Record<string, unknown>) => string;

export function timeAgo(date: string, t: TimeAgoTranslate): string {
  const ms = Date.now() - new Date(date).getTime();
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return t('timeAgo.minutes', { count: mins });
  const hours = Math.floor(mins / 60);
  if (hours < 24) return t('timeAgo.hours', { count: hours });
  const days = Math.floor(hours / 24);
  return t('timeAgo.days', { count: days });
}
